import React, { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';

import AuthenticatedRoute from './AuthenticatedRoute';
import ChallengedRoute from './ChallengedRoute';
import UnauthenticatedRoute from './UnauthenticatedRoute';

import Loader from '../components/page/Loader';
import config from '../config';

// public pages
const HomePage = lazy(() => retry(() => import('../containers/public/Home')));
const GetTheApp = lazy(() => retry(() => import('../containers/public/GetTheApp')));
const OpenTheApp = lazy(() => retry(() => import('../containers/public/OpenTheApp')));
const NotFoundPage = lazy(() => retry(() => import('../containers/common/NotFound')));
const TermsPage = lazy(() => retry(() => import('../containers/common/Terms')));
const SubscriptionTermsPage = lazy(() => retry(() => import('../containers/common/SubscriptionTerms')));
const PrivacyPage = lazy(() => retry(() => import('../containers/common/Privacy')));

// authentication
const SigninPage = lazy(() => retry(() => import('../containers/authentication/Signin')));
const SignupPage = lazy(() => retry(() => import('../containers/authentication/Signup')));
const RegistrationClosedPage = lazy(() => retry(() => import('../containers/authentication/RegistrationClosed')));
const SignupConfirmationPage = lazy(() => retry(() => import('../containers/authentication/SignupConfirmation')));
const ForgotPasswordPage = lazy(() => retry(() => import('../containers/authentication/ForgotPassword')));
const ForgotPasswordResetPage = lazy(() => retry(() => import('../containers/authentication/ForgotPasswordReset')));
const ChallengePasswordPage = lazy(() => retry(() => import('../containers/authentication/ChallengePassword')));

// private pages
const UserRecordingsPage = lazy(() => retry(() => import('../containers/private/recordings/Recordings')));

const retry = (fn, retriesLeft = 5, interval = 500) => {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            // reject('maximum retries exceeded');
            reject(error);
            return;
          }

          // Passing on "reject" is the important part
          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
};

const Routes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Switch>
        <Route path="/" exact>
          <HomePage />
        </Route>
        <Route path="/get-the-app" exact>
          <GetTheApp />
        </Route>
        <Route path="/c/:linkcode" exact showNav={false}>
          <OpenTheApp />
        </Route>
        <Route path="/terms" exact>
          <TermsPage />
        </Route>
        <Route path="/subscription-terms" exact>
          <SubscriptionTermsPage />
        </Route>
        <Route path="/privacy" exact>
          <PrivacyPage />
        </Route>

        <UnauthenticatedRoute path="/signup" exact>
          {config.site.REGISTRATION_ENABLED ? <SignupPage /> : <RegistrationClosedPage />}
        </UnauthenticatedRoute>
        <UnauthenticatedRoute path="/signup/confirmation" exact>
          <SignupConfirmationPage />
        </UnauthenticatedRoute>
        <UnauthenticatedRoute path="/signin" exact>
          <SigninPage />
        </UnauthenticatedRoute>
        <UnauthenticatedRoute path="/signin/forgot" exact>
          <ForgotPasswordPage />
        </UnauthenticatedRoute>
        <UnauthenticatedRoute path="/signin/forgot/reset" exact>
          <ForgotPasswordResetPage />
        </UnauthenticatedRoute>

        <ChallengedRoute path="/signin/new-password" exact>
          <ChallengePasswordPage />
        </ChallengedRoute>

        <AuthenticatedRoute path="/recordings" exact>
          <UserRecordingsPage />
        </AuthenticatedRoute>

        <Route>
          <NotFoundPage />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default Routes;
